import { createSlice } from '@reduxjs/toolkit';
import { ReducerType } from './types';
const initialState = {
    order: null
};
const confirmationSlice = createSlice({
    name: ReducerType.Confirmation,
    initialState,
    reducers: {
        resetConfirmation: () => initialState,
        setConfirmationOrder: (state, action) => {
            state.order = action.payload;
        }
    }
});
export const { resetConfirmation, setConfirmationOrder } = confirmationSlice.actions;
export const selectConfirmationOrder = (state) => state.confirmation.order;
export const confirmationReducer = confirmationSlice.reducer;
